const CART_CONST = {
    ADD_TO_CART: 'ADD_TO_CART',
    REMOVE_CART_ITEM: 'REMOVE_CART_ITEM',
};

export default CART_CONST;
